<template>
  <div class="work_tab">
    <div style="width: 95%; margin: auto">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="创建时间：">
            <el-date-picker
              clearable
              v-model="formInline.time"
              type="datetimerange"
              align="center"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="接诊状态：">
            <el-select
              v-model="formInline.region"
              placeholder="接诊状态"
              clearable
            >
              <el-option
                v-for="(item, index) in ORDER_STATUS"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="患者姓名：">
            <el-input
              clearable
              v-model="formInline.user"
              placeholder="请输入患者姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="0"> </el-tab-pane>
          <el-tab-pane
            v-for="(item, index) in treatmentTypes"
            :key="index"
            :name="item.id"
            :label="item.name"
          ></el-tab-pane>
        </el-tabs>
        <PatientItem v-if="total" :patientList="dataList"></PatientItem>
        <el-empty v-else description="暂无数据"></el-empty>
        <el-pagination
          @current-change="currentPageChange"
          :page-size="pageList.pageSize"
          :current-page="pageList.current"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align: center"
        ></el-pagination>
      </div>
    </div>
    <!-- <Vfooter /> -->
  </div>
</template>

<script>
import axios from 'axios';
import util from '@/utils';
import MyDiagnosis from '../../components/myDiagnosis/index';
import PlatDiagnosis from '../../components/platDiagnosis/index';
import UserInfo from '../../components/userInfo/index';
import ListInfo from '../../components/listInfo/index';
import VAppointment from './children/appointment';
import VConsultation from './children/consultation';
import Vfooter from '@/components/footer/index.vue';
import PatientItem from './children/patientItem.vue';
import { getOrderList, getServiceList } from '@/api/index.js';
import { ORDER_STATUS, ORDER_TYPE } from '@/utils/constants';
import cookie from "@/utils/cookie.js";

export default {
  name: 'userinfo',
  data() {
    return {
      total: 0,
      ORDER_STATUS,
      ORDER_TYPE,
      formInline: {},
      activeName: '',
      dataList: [],
      pageList: {
        pageSize: 12,
        current: 1,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      superMan: 'p2p-21232f297a57a5a743894a0e4a801fc3',
      // activeName: "prescription",
      form: [],
      userInfo: {},
      isCurTab: 1,
      curTabUrl: '/index/work/consultation',
      treatmentTypes: {
        1: '图文咨询',
        2: '电话咨询',
        3: '视频咨询',
        // 4: '视频服务',
        5: '图文问诊',
        6: '电话问诊',
        7: '视频问诊',
        8: '报告解读',
        9: '戒烟服务',
      },
    };
  },
  components: {
    VAppointment,
    VConsultation,
    ListInfo,
    MyDiagnosis,
    PlatDiagnosis,
    UserInfo,
    Vfooter,
    PatientItem,
  },
  watch: {
    // 更新页面所在位置，用于判断是前进页还是后退页
    $route(to, from) {
      var cur = to.path.split('/')[3];
      switch (cur) {
        case 'consultation':
          this.isCurTab = 1;
          break;
        case 'patients':
          this.isCurTab = 2;
          break;
        case 'appointment':
          this.isCurTab = 3;
          break;
        case 'videoment':
          this.isCurTab = 4;
          break;
        default:
          this.isCurTab = 1;
          break;
      }
    },
  },
  computed: {
    sumUnread() {
      let msgList = this.$store.state.sessionlist;
      let unRead = 0;
      msgList.forEach((item) => {
        unRead = unRead + item.unread;
      });
      return unRead;
    },
  },
  created() {
    this.getServiceList();
    this.readyIndexForm();
    this.getDoctorInfo();
    this.initPageTab();
    this.readyPatientList();
    if (this.$store.state.isUpdate) {
      this.isUpdatePopup();
    }
    return this.$store.state.sessionlist;
  },

  mounted() {
    window.onresize = () => {
      // 可以防止报错
      this.$refs.MyDiagnosis && this.$refs.MyDiagnosis.resize();
      this.$refs.PlatDiagnosis && this.$refs.PlatDiagnosis.resize();
      // this.$refs.MyDiagnosis.resize();
      // this.$refs.PlatDiagnosis.resize();
    };
    if(this.$route.query.imAccid)cookie.setCookie("uid", this.$route.query.imAccid);
    if(this.$route.query.imToken)cookie.setCookie("sdktoken", this.$route.query.imToken);
  },
  methods: {
    async readyPatientList() {
      try {
        const that = this;
        let startTime;
        let endTime;
        if (that.formInline.time) {
          startTime = that.formInline.time[0];
          endTime = that.formInline.time[1];
        }
        let params = {
          status: that.formInline.region == '0' ? '' : that.formInline.region,
          doctorId: util.getStore('user_id'),
          startTime: startTime,
          endTime: endTime,
          currentPage: that.pageList.current,
          pageSize: that.pageList.pageSize,
          patientName: that.formInline.user,
          serviceId: that.activeName == '0' ? '' : that.activeName,
        };
        let res = await getOrderList(params);
        if (res.code == 1) {
          this.dataList = res.data.dataList;
          this.total = Number(res.data.totalCount);
        } else {
          that.$message({
            showClose: true,
            message: res.message,
            type: 'error',
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClick() {
      this.pageList.current = 1;
      this.readyPatientList();
    },
    currentPageChange(page) {
      this.pageList.current = page;
      this.readyPatientList();
    },
    onSubmit() {
      this.pageList.current = 1;
      this.readyPatientList();
    },

    isUpdatePopup() {
      this.$confirm(
        '您的密码已经三个月没有更新了，建议您立即修改密码',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
      )
        .then((btn) => {
          if (btn == 'confirm') {
            this.$router.push({
              path: '../user/setup',
              query: {
                cp: 1,
              },
            });
          }
        })
        .catch(() => {
          this.$store.commit('SET_ISUPDATE_FN', false);
        });
    },
    initPageTab() {
      var cur = this.$route.path.split('/')[3];
      switch (cur) {
        case 'consultation':
          this.isCurTab = 1;
          break;
        case 'patients':
          this.isCurTab = 2;
          break;
        case 'appointment':
          this.isCurTab = 3;
          break;
        case 'videoment':
          this.isCurTab = 4;
          break;
        default:
          this.isCurTab = 1;
          break;
      }
    },
    //im连接获取session列表
    initEvent() {
      this.$store.dispatch('connect');
      this.$store.dispatch('updateRefreshState');
    },
    //tab点击事件
    tabHandle(tab, url) {
      this.isCurTab = tab;
      this.$router.push({
        path: url,
      });
    },
    //更多
    tabMore() {
      //我的患者
      this.$router.push({
        path: '/index/user/patients',
      });
    },
    /**
     * 获取今日快报和认证接口
     */
    async readyIndexForm() {
      try {
        let res = await getIndexForm({});
        if (res.success) {
          this.form = res.result;
          if (this.form.dateDifference && this.form.dateDifference[0].value) {
            this.$confirm(
              '您的密码已经三个月没有更新了，建议您立即修改密码',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
              },
            ).then((btn) => {
              if (btn == 'confirm') {
                this.$router.push({
                  path: '../user/setup',
                  query: {
                    cp: 1,
                  },
                });
              }
            });
          }
        }
      } catch (error) {}
    },
    /**
     * 获取医生信息
     */
    async getDoctorInfo() {
      try {
        let { code, data } = await getDoctorInformation();
        if (code === 1) {
          console.log(data);
          this.userInfo = data;
          this.$store.commit('setProfileStep', data.profileStep);
          this.$store.commit('setStatus', data.status);
          util.setStore(
            'username',
            this.userInfo.familyName + this.userInfo.firstName,
          );
        }
      } catch (error) {}
    },
    /**
     * 获取服务信息
     */
    async getServiceList() {
      try {
        let { code, data } = await getServiceList();
        if (code === 1) {
          this.treatmentTypes = data;
        }
      } catch (error) {}
    },
  },
  destroyed() {
    //移除监听器
    window.removeEventListener('onmessageWS', this.getSocketData);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  padding-bottom: 0px;
}

.work_tab {
  height: 100%;
  min-width: 1200px;
  margin-top: 15px;
  .warpper {
    display: flex;
    width: 100%;
    padding-bottom: 20px;
    background: #f5f6fa;

    .left_box,
    .right_box {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .item {
      margin: 5px;
      .clearfix {
        height: 56px;
        line-height: 56px;
        background: #fff8f3;
        // box-shadow: 0 -4px 10px #ccc;
        text-align: center;
        border-radius: 6px 6px 0 0;
        border: 1px solid #ebeef5;
        border-bottom: none !important;
        .tab_item {
          cursor: pointer;
        }
      }
    }

    .center_box {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .tab_warpper {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      background: #fff8f3;
    }

    .tabActive {
      color: #fc701a !important;
      font-weight: bold;
    }
    .tabActive::after {
      content: '';
      display: block;
      left: 15px;
      width: 50px;
      margin: auto;
      border-bottom: 3px solid #fc701a;
    }
  }

  .con_text {
    height: 740px;
    overflow: auto;
  }
}

.item .el-card {
  box-shadow: none !important;
  border-radius: 0 0 6px 6px;
  border-top: none !important;
}

.clearfix .tab_item {
  margin-top: 0 !important;
}
</style>
